import { IDocumentsState } from './Documents';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { Modal } from '../common/Modal';
import { TEXTS } from '../../core/texts';
import { FileCopy } from '@mui/icons-material';
import { useNotification } from '../../+state/useNotification';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { Loader } from '../common/Loader';
import { Typography } from '@mui/material';
import { ColumnBoxFlexFullWidth } from '../common/boxes';
import DocumentsTable from './DocumentsTable';
import { useGetCustomerDocRevisions } from '../../queryHooks/customer/useGetCustomerDocRevisions';

interface IProps {
  state: IDocumentsState;
  setState: Dispatch<SetStateAction<IDocumentsState>>;
}

const DocumentRevisionModal = ({ state, setState }: IProps) => {
  const onClose = useCallback(() => setState(prev => ({ ...prev, revisionId: null, download: null })), [setState]);
  const { openErrorToast } = useNotification();
  const { data, isFetching } = useGetCustomerDocRevisions({
    customerId: state.customerId!,
    revisionId: state.revisionId!,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(err.response?.data.message || err.message);
      onClose();
    }
  });
  return (
    <Modal onClose={onClose} maxWidth={'fit-content'} minWidth={500} title={TEXTS.REVISION_FILES} headerIcon={<FileCopy color={'primary'}/>}>
      {
        isFetching && <Loader width={50}/>
      }
      {
        data &&
        <ColumnBoxFlexFullWidth>
          {
            data.length === 0
              ? <Typography>{TEXTS.NO_RECORDS_FOUND}</Typography>
              : <DocumentsTable documents={data} state={state} setState={setState} revisionId={state.revisionId || ''}/>
          }
        </ColumnBoxFlexFullWidth>
      }
    </Modal>
  );
};

export default DocumentRevisionModal;